// extracted by css-extract-rspack-plugin
export default {"container":"right-side-module__container___K0pM5","wrapper":"right-side-module__wrapper___SVdp_","panel":"right-side-module__panel___eTXZj","ad":"right-side-module__ad___wB0W6"};